
import { fetchImageAsBase64 } from "../../utils/ImageHandler";
import { CONTENT_WIDTH } from "../../utils/pdfConstants";


export async function renderPTSBlock(data, content, report, contentWidth = CONTENT_WIDTH) {
  const imgData = data?.imageRef;
  if (!imgData) {
    content.push({ text: "Ei kuvaa saatavilla.", style: "paragraph", margin: [0, 0, 0, 0] });
    return;
  }

  const base64 = await fetchImageAsBase64(imgData, report);
  if (!base64) {
    content.push({ text: "Kuvaa ei voitu ladata PDF:ään.", style: "paragraph", margin: [0, 0, 0, 0] });
    return;
  }

  const description = imgData.metadata?.description || "";
  const imageFullWidth = contentWidth;
  const MAX_HEIGHT = 650; // cap height to avoid huge images

  // Helper: get actual image dimensions
  const getImageDimensions = (base64) =>
    new Promise((resolve) => {
      const img = new Image();
      img.onload = () => resolve({ width: img.width, height: img.height });
      img.src = base64;
    });

  const { width: imgWidth, height: imgHeight } = await getImageDimensions(base64);

  // proportional height based on full width
  let finalHeight = (imgHeight / imgWidth) * imageFullWidth;
  if (finalHeight > MAX_HEIGHT) finalHeight = MAX_HEIGHT;

  content.push({
    stack: [
      {
        image: base64,
        width: imageFullWidth,
        height: finalHeight,
        alignment: "left",
        margin: [0, 0, 0, 0],
      },
    //   description ? { text: description, style: "paragraph", margin: [0, 2, 0, 6] } : null,
    ].filter(Boolean),
    margin: [0, 0, 0, 0],
  });
}